import {BoxedType} from '@enum/common/boxed-type';
import {PlacementOptional} from '@interface/model/placement/placement.optional';

export interface BoxedStructure {
  boxName: string;
  boxId: number;
  boxedType: BoxedType.BOXED;
  placementOptionalList: PlacementOptional[];
  atLeastOneConfigurable: boolean;
  maxQuantity: number | false;
}

export type OptionalsStructure = {
  [BoxedType.BOXED]: BoxedStructure[];
  [BoxedType.UNBOXED]: PlacementOptional[];
};

export type OptionalBoxedUnboxed = BoxedStructure | PlacementOptional;

export function isBoxedStructure(placement: any): placement is BoxedStructure {
  return placement.boxedType === BoxedType.BOXED && placement.boxId;
}
